import React, { FC, useContext } from 'react';
// context
import { useLanguageSelectors } from 'src/app/reducers/languageReducer';
// components
import { SkeletonText } from '@ems/client-design-system';
import { PageHeader, DateFilter } from 'src/components';
// fns
import { IHeaderContainer } from 'src/@infringementsCandidates/interfaces';
import { formatNumber, setTabTitle } from 'src/utils';
import { withQueryStringUpdater } from 'src/app/hocs/withQueryStringUpdater';

import { InfringementDispatchContext } from 'src/@infringementsCandidates/providers/InfringementsStateProvider';
import { useGetInfringements } from 'src/@infringements/hooks';

export const HeaderContainer: FC<IHeaderContainer> = ({ updateUrl }) => {
  // Translation
  const languageSelectors = useLanguageSelectors();
  const {
    components: {
      labels: {
        table: { totalItems },
      },
    },
    screens: {
      infringements: { title },
    },
  } = languageSelectors.getLanguage();

  const dispatcher = useContext<any>(InfringementDispatchContext);
  const { data: fetchedData, loading } = useGetInfringements(dispatcher);

  const DateFilterHoc = withQueryStringUpdater({ Container: DateFilter, updateUrl });

  setTabTitle(title);

  return (
    <PageHeader title={title}>
      <SkeletonText
        loading={loading || typeof fetchedData === 'undefined' || fetchedData.items.length === 0}
        width="4rem">
        <span className="page-count">
          {fetchedData && fetchedData.totalCount && formatNumber(fetchedData.totalCount)}{' '}
          {totalItems}
        </span>
      </SkeletonText>
      <div>
        <DateFilterHoc />
      </div>
    </PageHeader>
  );
};
